import React from 'react'

import { ZariContext } from '_zari/context'

import * as AuthService from 'services/auth.service'
import * as LicenciaService from 'services/licencia.service'

const AdminContext = React.createContext({
  _idIsla: null,
  _idIslaActiva: null,
  _idUsuario: null,
  setIdIslaActiva: null,
  valoresConfiguracionCompania: null,
  valoresConfiguracionSede: null,
  valoresConfiguracionUsuario: null,
  estadoTurno: null,
  setEstadoTurno: null,
  fechaTrabajo: null,
  setFechaTrabajo: null,
  mesTrabajo: null,
  anioTrabajo: null,
  setMesTrabajo: null,
  nombreCompania: null,
  nombreSede: null,
  transacciones: null,
  usuario: null,
  ultimoTipoCambio: null
})

const { Provider } = AdminContext

const AdminProvider = props => {
  const __zariContext = React.useContext(ZariContext)

  const [_idIsla, setIdIsla] = React.useState(null)
  const [_idIslaActiva, setIdIslaActiva] = React.useState(null)
  const [estadoTurno, setEstadoTurno] = React.useState(null)
  const [valoresConfiguracionCompania, setValoresConfiguracionCompania] = React.useState({})
  const [valoresConfiguracionSede, setValoresConfiguracionSede] = React.useState({})
  const [valoresConfiguracionUsuario, setValoresConfiguracionUsuario] = React.useState({})
  const [fechaTrabajo, setFechaTrabajo] = React.useState(null)
  const [mesTrabajo, setMesTrabajo] = React.useState('')
  const [anioTrabajo, setAnioTrabajo] = React.useState('')
  const [nombreCompania, setNombreCompania] = React.useState('')
  const [nombreSede, setNombreSede] = React.useState('')
  const [transacciones, setTransacciones] = React.useState([])
  const [usuario, setUsuario] = React.useState('')
  const [_idUsuario, setIdUsuario] = React.useState(null)
  const [ultimoTipoCambio, setUltimoTipoCambio] = React.useState(0)

  const oneTryRef = React.useRef(false)

  React.useEffect(() => {
    AuthService.getSesionInfo()
      .then(({ data }) => {
        setIdIsla(data._idIsla)
        setIdIslaActiva(data._idIslaActiva)
        setMesTrabajo(data.mesTrabajo)
        setAnioTrabajo(data.anioTrabajo)
        setNombreCompania(data.compania)
        setNombreSede(data.sede)
        setFechaTrabajo(data.fechaTrabajo)
        setEstadoTurno(data.estadoTurno)
        setValoresConfiguracionCompania(data.configuracionCompania)
        setValoresConfiguracionSede(data.configuracionSede)
        setValoresConfiguracionUsuario(data.configuracionUsuario)
        setUltimoTipoCambio(data.ultimoTipoCambio)
        setTransacciones(data.configuracionUsuario.transacciones)
        setUsuario(data.usuario || 'Usuario')
        setIdUsuario(data._id || '_id')
      })
      .catch(() => console.log('error', 'No se ha podido obtener la fecha de trabajo.'))
  }, [])

  React.useEffect(() => {
    if (!oneTryRef.current) {
      LicenciaService.validarLicencia()
        .then(({ data }) => {
          if (data && data.mensaje) {
            __zariContext.snack('warning', data.mensaje)
          }
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
      oneTryRef.current = true
    }
  }, [__zariContext])

  return (
    <Provider
      value={{
        _idIsla,
        _idIslaActiva,
        setIdIslaActiva,
        valoresConfiguracionCompania,
        valoresConfiguracionSede,
        valoresConfiguracionUsuario,
        estadoTurno,
        setEstadoTurno,
        fechaTrabajo,
        setFechaTrabajo,
        mesTrabajo,
        anioTrabajo,
        setMesTrabajo,
        nombreCompania,
        nombreSede,
        transacciones,
        usuario,
        _idUsuario,
        ultimoTipoCambio
      }}
    >
      {transacciones ? <>{props.children}</> : <></>}
    </Provider>
  )
}

export { AdminProvider, AdminContext }
